import { beam } from '@styles/colors/themes';
import styled, { keyframes } from 'styled-components';
import { ControlledMenu } from '@szhsin/react-menu';
import { menuSelector } from '@szhsin/react-menu/style-utils';

export const Wrapper = styled.div``;

export const AssignedTo = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  column-gap: 8px;
`;

export const AssignToWrapper = styled.div`
  position: relative;
`;

export const EmptyAssignedTo = styled.div`
  display: flex;
  align-items: center;

  & span {
    display: inline-flex;
    border: 1px dashed #c1c4d6;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
  }
`;

export const AssineeImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 12px;
`;

export const AsigneeName = styled.span`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
`;

const menuShow = keyframes`
  from {
    opacity: 0;
  }
`;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
`;

export const Menu = styled(ControlledMenu)`
  ${menuSelector.name} {
    font-size: 0.925rem;
    user-select: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
    border-radius: 8px;
    padding: 12px 16px 24px 16px;
    min-width: 300px;
    transition: unset;
  }

  ${menuSelector.stateOpen} {
    animation: ${menuShow} 0.2s linear;
  }

  ${menuSelector.stateClosing} {
    animation: ${menuHide} 0.2s ease-out forwards;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
`;

export const Close = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;

  span {
    display: inline-flex;
  }

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Remove = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 2px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Back = styled.img`
  cursor: pointer;
`;

export const Form = styled.form`
  width: 100%;
`;

export const Divider = styled.div`
  height: 16px;
`;

export const Item = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  color: ${beam.font.primary};
  cursor: pointer;

  :hover {
    background-color: #f5f7fb;
    border-radius: 4px;

    &[data-no-bg] {
      background-color: transparent;
      border-radius: 0;
    }
  }
`;

export const Label = styled.h2`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  margin: unset;

  &.h1 {
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 4px;
  }
`;

export const ItemNoFeedback = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: ${beam.font.primary};
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 16px;
  align-self: center;
`;

export const InputSearch = styled.input`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 100%;

  &::placeholder {
    color: #8f95b2;
  }
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
`;

export const Avatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 12px;
`;

export const Items = styled.div`
  overflow: auto;
  height: 65%;
  max-height: 300px;
  width: 356px;

  &.asset {
    width: 100%;
    height: unset;
  }
`;

export const UsersSeparator = styled.div`
  height: 1px;
  width: 100%;
  background: #e6e8f0;
  margin: 16px 0;
`;

export const SearchCloseIconContainer = styled.div`
  position: absolute;
  right: 12px;
  cursor: pointer;
  height: 20px;
`;
